$(function() {
    // See More Content Component
    const SeeMoreContent = {
        // Initialize the component
        init: function() {
            const hasContent = document.querySelector('.see-more-content');
            if (!hasContent) return; // Exit early if no .see-more-content exists

            this.setupSeeMorePairs();
            this.bindEvents();
        },

        // Setup button-content pairs within each section
        setupSeeMorePairs: function() {
            const sections = document.querySelectorAll('.image-with-text');

            sections.forEach((section) => {
                const button = section.querySelector('.see-more-btn');
                const content = section.querySelector('.see-more-content');

                if (button && content) {
                    // Store reference to paired content in button
                    button.setAttribute('data-content-id', this.generateId());
                    content.setAttribute('data-content-id', button.getAttribute('data-content-id'));

                    // Setup initial state
                    content.style.height = 'auto';
                    const naturalHeight = content.scrollHeight;
                    content.setAttribute('data-natural-height', naturalHeight);

                    // Set initial state to collapsed
                    content.style.height = '0px';
                    content.setAttribute('data-expanded', 'false');

                    // Store original text
                    button.setAttribute('data-original-text', button.textContent);
                }
            });
        },

        // Generate unique ID
        generateId: function() {
            return 'see-more-' + Math.random().toString(36).substr(2, 9);
        },

        // Bind event listeners
        bindEvents: function() {
            const self = this;

            // Use event delegation for better performance and dynamic content support
            document.addEventListener('click', function(e) {
                if (e.target.classList.contains('see-more-btn')) {
                    e.preventDefault();
                    self.toggleContent(e.target);
                }
            });

            // Handle window resize
            window.addEventListener('resize', () => {
                self.handleResize();
            });
        },

        // Toggle content visibility
        toggleContent: function(button) {
            const contentId = button.getAttribute('data-content-id');
            const content = document.querySelector(`[data-content-id="${contentId}"].see-more-content`);

            if (!content) return;

            const isExpanded = content.getAttribute('data-expanded') === 'true';
            const naturalHeight = parseInt(content.getAttribute('data-natural-height'));
            const originalText = button.getAttribute('data-original-text');

            if (isExpanded) {
                // Collapse
                content.style.height = '0px';
                content.setAttribute('data-expanded', 'false');
                button.textContent = originalText;
            } else {
                // Expand
                content.style.height = naturalHeight + 'px';
                content.setAttribute('data-expanded', 'true');
                button.textContent = window.theme.custom.global.see_less;
            }
        },

        // Recalculate heights on resize
        handleResize: function() {
            const contents = document.querySelectorAll('.see-more-content');
            contents.forEach((content) => {
                // Temporarily remove height constraint to measure natural height
                const currentHeight = content.style.height;
                content.style.height = 'auto';
                const naturalHeight = content.scrollHeight;
                content.setAttribute('data-natural-height', naturalHeight);

                // Restore the appropriate height
                const isExpanded = content.getAttribute('data-expanded') === 'true';
                content.style.height = isExpanded ? naturalHeight + 'px' : '0px';
            });
        },
    };

    // Initialize See More Content when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            SeeMoreContent.init();
        });
    } else {
        // DOM is already ready
        SeeMoreContent.init();
    }

    // Reinitialize on DOM changes (for dynamic content)
    if (window.MutationObserver) {
        const observer = new MutationObserver(function(mutations) {
            let shouldReinit = false;
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) { // Element node
                            if (node.classList && node.classList.contains('image-with-text')) {
                                shouldReinit = true;
                            }
                            if (node.querySelector && node.querySelector('.image-with-text')) {
                                shouldReinit = true;
                            }
                        }
                    });
                }
            });
            if (shouldReinit) {
                SeeMoreContent.setupSeeMorePairs();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    // Dropdown Content Component
    const DropdownContent = {
        // DOM elements
        buttons: null,
        contents: null,

        // Initialize the component
        init: function() {
            this.cacheElements();

            if (!this.buttons.length || !this.contents.length) {
                return;
            }

            this.setupInitialState();
            this.bindEvents();
        },

        // Cache DOM elements
        cacheElements: function() {
            this.buttons = document.querySelectorAll('.sk-worldwide__mobile-header');
            this.contents = document.querySelectorAll('.sk-worldwide__mobile-dropdown');
        },

        // Setup initial state
        setupInitialState: function() {
            this.contents.forEach((content, index) => {
                // Store the natural height
                content.style.maxHeight = 'none';
                const naturalHeight = content.scrollHeight;
                content.setAttribute('data-natural-height', naturalHeight);

                // Set initial state to collapsed
                content.style.maxHeight = '0px';
                content.setAttribute('data-expanded', 'false');
            });
        },

        // Bind event listeners
        bindEvents: function() {
            const self = this;

            // Add click event listeners for buttons
            this.buttons.forEach((button, index) => {
                button.addEventListener('click', () => {
                    self.toggleContent(index);
                });
            });
        },

        // Toggle content visibility
        toggleContent: function(index) {
            const content = this.contents[index];
            const button = this.buttons[index];
            const arrow = button.querySelector('.sk-worldwide__mobile-arrow');

            if (!content || !button) return;

            const isExpanded = content.getAttribute('data-expanded') === 'true';
            const naturalHeight = parseInt(content.getAttribute('data-natural-height'));

            if (isExpanded) {
                // Collapse
                content.style.maxHeight = '0px';
                content.setAttribute('data-expanded', 'false');
                if (arrow) arrow.classList.remove('rotated');
            } else {
                // Expand
                content.style.maxHeight = naturalHeight + 'px';
                content.setAttribute('data-expanded', 'true');
                if (arrow) arrow.classList.add('rotated');
            }
        },

        // Recalculate heights on resize
        handleResize: function() {
            this.contents.forEach((content) => {
                // Temporarily remove height constraint to measure natural height
                const currentHeight = content.style.maxHeight;
                content.style.maxHeight = 'none';
                const naturalHeight = content.scrollHeight;
                content.setAttribute('data-natural-height', naturalHeight);

                // Restore the appropriate height
                const isExpanded = content.getAttribute('data-expanded') === 'true';
                content.style.maxHeight = isExpanded ? naturalHeight + 'px' : '0px';
            });
        },
    };

    // Initialize Dropdown Content
    DropdownContent.init();

    // Handle window resize for all components
    window.addEventListener('resize', function() {
        if (typeof SeeMoreContent !== 'undefined' && SeeMoreContent.contents && SeeMoreContent.contents.length > 0) {
            SeeMoreContent.handleResize();
        }
        if (typeof DropdownContent !== 'undefined' && DropdownContent.contents && DropdownContent.contents.length > 0) {
            DropdownContent.handleResize();
        }
    });

    // PDP product description read more
    const maxLength = 250;

    // --- helper: safely truncate HTML ---
    function truncateHtmlPreserveTags(html, limit) {
        const div = document.createElement('div');
        div.innerHTML = html;

        let charCount = 0;
        const walker = document.createTreeWalker(div, NodeFilter.SHOW_TEXT, null, false);
        const nodesToRemove = [];
        let reachedLimit = false;

        while (walker.nextNode()) {
            const node = walker.currentNode;
            const text = node.textContent;

            if (reachedLimit) {
                nodesToRemove.push(node);
                continue;
            }

            if (charCount + text.length > limit) {
                const remaining = limit - charCount;
                node.textContent = text.slice(0, remaining).trim() + '…';
                reachedLimit = true;
            }

            charCount += text.length;
        }

        // remove any text nodes beyond limit
        nodesToRemove.forEach(n => n.parentNode.removeChild(n));
        return div.innerHTML;
    }

    $('.rte.readmore').each(function() {
        const $el = $(this);
        const fullHtml = $el.html().trim();
        const truncatedHtml = truncateHtmlPreserveTags(fullHtml, maxLength);

        if (truncatedHtml === fullHtml) return; // no need to truncate

        $el.data('full-html', fullHtml);
        $el.data('truncated-html', truncatedHtml);
        $el.html(truncatedHtml + ` <a href="#" class="read-more">${window.theme.custom.global.pdp.read_more}</a>`);
    });

    // expand on click (no collapse)
    $(document).on('click', '.rte.readmore .read-more', function(e) {
        e.preventDefault();
        const $container = $(this).closest('.rte.readmore');
        const fullHtml = $container.data('full-html');
        $container.html(fullHtml); // replace truncated with full version
    });

    $(".js-selectmenu").selectmenu();

    function anchorScroll() {
        $(document).on("click", ".sk-link-scroll", function(e) {
            e.preventDefault();

            const targetId = $(this).attr("href");
            const $target = $(targetId);

            if ($target.length) {
                const targetPosition = $target.offset().top - $headerHeight;

                $root.animate({
                    scrollTop: targetPosition
                }, Math.min(1000, Math.abs($root.scrollTop() - targetPosition) / 2));
            }
        });
    }

    anchorScroll();
});
